module.exports = __webpack_public_path__ + "static/media/1018949.cec4b07c.jpg";